import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { Route } from '../core/route.service';
import { extract } from '../core/i18n.service';
import { ItineraryDetailComponent } from './itinerary-detail.component';

const routes: Routes =[
  { path: 'itinerary-detail', component: ItineraryDetailComponent, data: { title: extract('Itinerary Detail') } },
  { path: 'reservation-confirmation', component: ItineraryDetailComponent, data: { title: extract('Reservation Confirmation') } }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class ItineraryDetailRoutingModule { }
